import { apiJsonHeaders } from "../utils/apiLocale";

const BASE_URL = "/api/patient-health-history";

export const fetchPatientHealthHistory = async (patientId) => {
  const res = await fetch(`${BASE_URL}/${patientId}`, {
    method: "GET",
    headers: apiJsonHeaders(),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al obtener el historial de salud");
  }

  return res.json();
};
